﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customProductSheetImageList from './tpl/customProductSheetImageList.html';
import View_CustomProductSheetImageListItem from './customProductSheetImageListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customProductSheetImageList',
    childViewContainer: '#customProductSheetImageList',
    childView: View_CustomProductSheetImageListItem,
    getTemplate: function () {
        return tpl_customProductSheetImageList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
